<template>
  <div>
    <navbar>
      <template #before>
        <router-link to="/" class="btn btn-sm btn-outline-light">
          Home
        </router-link>
      </template>
      <template #title>
        <span class="navbar-brand">Admin » Products</span>
      </template>
      <div class="d-flex">
        <input
          type="text"
          id="search"
          v-model="search"
          placeholder="Search"
          class="form-control form-control-sm"
        />
        <a
          href="http://reports.cancab.net/crons/sdsSync"
          target="_blank"
          class="btn btn-sm btn-outline-light ms-2"
        >
          Sync
        </a>
        <router-link
          to="/admin/products/create"
          class="btn btn-sm btn-outline-light ms-2"
        >
          Add
        </router-link>
        <router-link
          to="/admin/users"
          class="btn btn-sm btn-outline-light ms-2"
        >
          Users
        </router-link>
      </div>
    </navbar>
    <container>
      <div class="my-3">
        <div class="progress" v-if="loading">
          <div
            class="progress-bar text-end px-1"
            role="progressbar"
            :style="`width: ${complete}%`"
            :aria-valuenow="complete"
            aria-valuemin="0"
            aria-valuemax="100"
            v-text="`${complete}%`"
          ></div>
        </div>
      </div>
      <div class="list-group mb-3">
        <router-link
          class="list-group-item list-group-item-action"
          v-for="product of filtered"
          :to="`/admin/products/${product.id}`"
          :key="product.id"
        >
          <sds-product :product="product"></sds-product>
        </router-link>
      </div>
    </container>
  </div>
</template>
<script>
import SdsProduct from "../../../components/SdsProduct.vue";
export default {
  components: { SdsProduct },
  name: "AdminProducts",
  data: () => ({
    products: [],
    search: null,
    complete: 0,
    loading: false,
  }),
  computed: {
    filtered() {
      let data = this.products;
      if (this.search) {
        data = data.filter((p) => {
          return JSON.stringify(Object.values(p))
            .toLowerCase()
            .includes(this.search.toLowerCase());
        });
      }
      return data;
    },
  },
  methods: {
    load(page = 1) {
      this.loading = true;
      this.axios.get(`/api/products.json?page=${page}`).then((res) => {
        this.products = this.products.concat(res.data.Products);

        this.complete = _.round(
          (res.data.pager.Products.page / res.data.pager.Products.pageCount) *
            100,
          0
        );

        if (res.data.pager.Products.nextPage) {
          // setTimeout(() => {
          this.load(res.data.pager.Products.page + 1);
          // }, 300);
        } else {
          this.loading = false;
        }
      });
    },
  },
  mounted() {
    this.load();
  },
};
</script>
